import { createContext, useContext, useState } from "react";

const CommentsContext = createContext()

export const CommentsProvider = ({ children }) => {
    const [reloadGrid, setReloadGrid] = useState(false)
    return (
        <CommentsContext.Provider
            value={{
                reloadGrid,
                setReloadGrid,
            }}
        >
            {children}
        </CommentsContext.Provider>
    )
}

export function useComments() {
    return useContext(CommentsContext)
}